import React, { useEffect, useState } from 'react';
import classes from "./PromoQuiz.module.css";
import Header from '../../components/Header';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getQuiz, saveUserPoints } from '../../http/http';
import { storeQuestions } from '../../store/slices/questionsSlice';
import { DecreaseTime, IncreaseTimeForProgress, ResetTime, SetProgress } from '../../store/slices/timeSlice';
import CircularProgress from '@mui/material/CircularProgress';
import { IncreaseIndex } from '../../store/slices/indexSlice';
import { increaseCorrectAnswer, increaseWrongAnswer, userScoreUpdate } from '../../store/slices/userPlayerSlice';
import { opponentScoreUpdate } from '../../store/slices/opponentPlayerSlice';
import CorrectAudio from '../../components/CorrectAudio';
import WrongAudio from '../../components/WrongAudio';
import ClockAudio from '../../components/ClockAudio';
import MediumLoader from '../../components/Loaders/MediumLoader';
import { FaArrowLeft } from "react-icons/fa6";
import Lottie from 'lottie-react';
import GameOverAnimation from "../../animations/gameOver.json";
import { useTranslation } from 'react-i18next';
import { removeUserToken } from '../../store/slices/userTokenSlice';
import { toast } from 'react-toastify';
import { imageBaseUrl } from '../../utils/constants';
import { fetchPromoQuestions, savePromoUserPoints } from '../../http/http';

const PromoQuiz = () => {
    const location = useLocation();
    const { userToken } = useSelector(state => state.persisted.userTokenSlice);
    const { questions } = useSelector(state => state?.persisted?.questionsSlice);
    const { timeClock, progress } = useSelector((state) => state?.persisted?.timeSlice);
    const { index } = useSelector(state => state?.persisted?.indexSlice);
    const { user, userScore } = useSelector(state => state?.persisted?.userPlayerSlice);
    const { opponent, opponentScore } = useSelector(state => state?.persisted?.opponentPlayerSlice);
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);

    const [gameOverLoading, setGameOverLoading] = useState(false);

    const [correct, setCorrect] = useState(null);
    const [wrong, setWrong] = useState(null);

    const [wrongSound, setWrongSound] = useState(null);
    const [correctSound, setCorrectSound] = useState(null);
    const [pointerEvents, setPointerEvents] = useState("all");

    const { selectedLanguage } = useSelector(state => state.languageSlice);

    const navigate = useNavigate();
    const { t } = useTranslation();

    const fetchQuizData = async () => {
        try {
            const response = await fetchPromoQuestions(selectedLanguage, userToken);
            setLoading(false);
            dispatch(storeQuestions(response?.data?.result?.data))
        } catch (error) {

            if (error?.response?.status == 403) {
                dispatch(removeUserToken());
                toast.error(t("52"));
                navigate('/');
            }
            else {
                toast.error(error?.response?.data?.error?.error || error?.response?.error?.error || error?.response?.error || "Something Went Wrong!");
            }
        }
    }

    useEffect(() => {
        if (!questions) {
            fetchQuizData();
        }
        else {
            setLoading(false);
        }

    }, [location]);

    useEffect(() => {
        if (!loading) {
            const intervalId = setInterval(() => {
                dispatch(DecreaseTime());
                dispatch(IncreaseTimeForProgress());
                dispatch(SetProgress());
            }, 1000);

            return () => clearInterval(intervalId);
        }
    }, [timeClock, dispatch, loading]);

    const savePoints = async () => {
        try {
            setGameOverLoading(true);

            console.log(user,'r');

            //    location?.state?.qid?.name || location?.state?.qid?.image
            const response = await savePromoUserPoints(1, 'Promo', `https://mcg.quizmasterr.com/assets/images/promo.png`, 1, userScore, user?.promo_points, userToken);
            setTimeout(() => {
                setGameOverLoading(false);
            }, 500);
            navigate("/promo/game-over")
        } catch (error) {

            if (error?.response?.status == 403) {
                dispatch(removeUserToken());
                toast.error(t("52"));
                navigate('/');
            }
            else {
                toast.error(error?.response?.data?.error?.error || error?.response?.error?.error || error?.response?.error || "Something Went Wrong!");
            }
        }
    }

    if (index === questions?.length && questions?.length > 0 && !loading && !gameOverLoading) {
        savePoints();
    }

    if (timeClock < 0 && !loading && !gameOverLoading) {
        savePoints();
    }

    const checkAnswerAndNextQuestion = (selectedOption, selectedOptionName) => {
        if (
            questions[index].correctAnswer == selectedOption
        ) {
            setCorrect(selectedOption);
            setCorrectSound(true);
            setWrongSound(false);
            setWrong(null);

            //We will increase the score
            dispatch(userScoreUpdate(5));
            dispatch(opponentScoreUpdate(5));
            dispatch(increaseCorrectAnswer(questions[index]));
            setPointerEvents("none");

            setTimeout(() => {
                setWrong(null);
                setCorrect(null);
                setCorrectSound(false);
                setWrongSound(false);
                dispatch(IncreaseIndex());
                // dispatch(ResetTime());
                setPointerEvents("all");
            }, 650);

        } else {
            setWrong(selectedOption);
            setWrongSound(true);
            setCorrect(null);
            setCorrectSound(false);
            dispatch(opponentScoreUpdate(5));
            dispatch(
                increaseWrongAnswer({
                    question: questions[index],
                    yourAnswer: selectedOptionName,
                })
            );
            setPointerEvents("none");

            setTimeout(() => {
                setWrong(null);
                setCorrect(null);
                setCorrectSound(false);
                setWrongSound(false);
                // dispatch(ResetTime());
                dispatch(IncreaseIndex());
                setPointerEvents("all");
            }, 650);
        }
    };


    return (
        <>
            <ClockAudio />
            {correctSound && <CorrectAudio />}
            {wrongSound && <WrongAudio />}
            {/* <Header hideLanguage={true} /> */}
            <div className={classes.header}>

                <div className={classes.back_button} onClick={() => {
                    navigate(-1);
                }}>
                    <FaArrowLeft className={classes.back_icon} />
                </div>
            </div>

            <div className={classes.container}>
                <div className={classes.section_header}>
                    <div className={classes.section_user_image}>
                        <div className={classes.user_image_container}>
                            <img src={user?.image ?? "/assets/images/dummy.png"} alt={t("1")} className={classes.user_image} />
                        </div>
                        <div className={classes.user_score_container}>
                            <p className={classes.user_name}>{t("1")}</p>
                            <p className={classes.score}>{userScore}</p>
                        </div>
                    </div>

                    <div className={classes.clock_container}>
                        <div className={classes.circular_clock_container}>
                            <CircularProgress variant="determinate" color="primary" value={progress} />
                            <p className={classes.clock_time} style={{ color: timeClock <= 10 && "red" }}>
                                {timeClock}
                            </p>
                        </div>
                    </div>

                    <div className={classes.section_opponent_image}>
                        <div className={classes.user_score_container}>
                            <p className={classes.user_name}>{opponent?.name ?? t("17")}</p>
                            <p className={classes.score}>{opponentScore}</p>
                        </div>
                        <div className={classes.user_image_container}>
                            <img src={opponent?.image ?? "/assets/images/dummy.png"} alt="opponent" className={classes.user_image} />
                        </div>

                    </div>
                </div>
                {loading ?
                    <div className={classes.game_over_animation_container}>
                        <MediumLoader />
                    </div>
                    : gameOverLoading ?
                        <div className={classes.game_over_animation_container}>
                            <Lottie animationData={GameOverAnimation} loop autoPlay className={classes.gameOverAnimation} />
                        </div>
                        :
                        questions?.length > 0 && <div className={classes.question_container}
                            style={{ pointerEvents: pointerEvents }}
                            key={index}
                        >
                            <p className={classes.question} >{questions[index]?.title}</p>

                            {questions[index]?.option_1 &&
                                <div className={`${classes.option_container} ${correct == "1"
                                    ? classes.right
                                    : wrong == "1"
                                        ? classes.wrong : null
                                    }`}
                                    onClick={() => {
                                        checkAnswerAndNextQuestion(1, questions[index]?.option_1)
                                    }}
                                >
                                    <p className={classes.option}>1). {questions[index]?.option_1}</p>
                                </div>
                            }


                            {questions[index]?.option_2 &&
                                <div className={`${classes.option_container} ${correct == "2"
                                    ? classes.right
                                    : wrong == "2"
                                        ? classes.wrong : null
                                    }`}
                                    onClick={() => {
                                        checkAnswerAndNextQuestion(2, questions[index]?.option_2)
                                    }}
                                >
                                    <p className={classes.option}>2). {questions[index]?.option_2}</p>
                                </div>
                            }

                            {questions[index]?.option_3 &&
                                <div className={`${classes.option_container} ${correct == "3"
                                    ? classes.right
                                    : wrong == "3"
                                        ? classes.wrong : null
                                    }`}
                                    onClick={() => {
                                        checkAnswerAndNextQuestion(3, questions[index]?.option_3)
                                    }}
                                >
                                    <p className={classes.option}>3). {questions[index]?.option_3}</p>
                                </div>
                            }

                            {questions[index]?.option_4 &&

                                <div className={`${classes.option_container} ${correct == "4"
                                    ? classes.right
                                    : wrong == "4"
                                        ? classes.wrong : null
                                    }`}
                                    onClick={() => {
                                        checkAnswerAndNextQuestion(4, questions[index]?.option_4)
                                    }}
                                >
                                    <p className={classes.option}>4). {questions[index]?.option_4}</p>
                                </div>
                            }
                        </div>
                }



            </div>

        </>

    )
}

export default PromoQuiz